import { useState } from 'react';
import Redux from 'services/gecko-store/redux';
import GeckoAuthService from '../../../../../../../../services/gecko-auth';

function useImportUpload(botId) {
  const [isUploading, setIsUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const setDone = () => {
    setIsUploading(false);
    setProgress(0);
  };

  const startUpload = (file) => {
    return new Promise((resolve, reject) => {
      const state = Redux.store.getState();
      const { apiUrl, defaultHeaders } = state.appState;

      setIsUploading(true);
      setProgress(0);

      const formData = new FormData();
      formData.append('file', file);
      const xhr = new XMLHttpRequest();
      xhr.onload = () => {
        if (xhr.status !== 200) {
          setDone();
          reject('Failed to upload file');
        } else {
          const fileDetails = JSON.parse(xhr.responseText);
          setDone();
          resolve(fileDetails);
        }
      };
      xhr.onerror = () => {
        setDone();
        reject('Failed to upload file');
      };
      xhr.upload.onprogress = (event) => {
        setProgress((1 - (event.total - event.loaded) / event.total) * 100); // convert to percentage left
      };
      xhr.open('POST', `${apiUrl}/bots/${botId}/imports`);
      GeckoAuthService.getToken().then((token) => {
        Object.entries({ ...defaultHeaders, Authorization: token })
          .filter(([name]) => name !== 'Content-Type')
          .forEach(([name, value]) => xhr.setRequestHeader(name, value));
        xhr.send(formData);
      });
    });
  };

  return [startUpload, isUploading, progress];
}

export default useImportUpload;
